/* eslint-disable max-len */
import React from 'react';
import { LFC } from '../../Legacy';
import { Position } from '../../ui/Position';
import { Popup, PopupProps } from '../popups/Popup';
import { BoardBuilderView } from './BoardBuilderView';

export const boardBuilderPopup = () => ({ ui: BoardBuilderPopup, fullscreen: true });

export const BoardBuilderPopup: LFC<PopupProps> = ({ dismiss }) => {
    return <Popup p="0">
        <BoardBuilderView onComplete={dismiss} />
        <Position at="topRight" inset=".5">
            <Popup.Close onAction={dismiss} />
        </Position>
    </Popup>;
};
